import { useSeo } from "@/hooks/useSeo";
import { getLatestGames, getPopularGames } from "@/utils/gameUtils";
import HomeHero from "./components/HomeHero";
import HomeCategories from "./components/HomeCategories";
import HomePopular from "./components/HomePopular";
import HomeLatest from "./components/HomeLatest";
import HomeAdvantages from "./components/HomeAdvantages";

export default function Home() {
  useSeo({
    title: "网页游戏直接玩_热门网页游戏大全在线试玩平台",
    description:
      "网页游戏直接玩为您提供海量热门网页游戏在线试玩，覆盖竞技、角色扮演、休闲等多种类型，支持免下载安装快速体验。",
    keywords: "网页游戏直接玩,网页游戏,在线游戏,在线试玩,热门网页游戏,免下载游戏,网页小游戏",
  });

  const popularGames = getPopularGames(8);
  const latestGames = getLatestGames(6);

  return (
    <>
      <HomeHero />
      <div className="mx-auto max-w-screen2xl space-y-14 px-4 py-12 md:space-y-20 md:px-6 md:py-16">
        <HomeCategories />
        <HomePopular games={popularGames} />
        <HomeLatest games={latestGames} />
        <HomeAdvantages />
      </div>
    </>
  );
}